interface Props {
  percent: number
}
export const ReadMeter: React.FC<Props> = ({ percent }) => {
  return (
    <div className="fixed bottom-0 left-0 w-[85px] h-[35px] text-[15px] leading-4 text-center text-white bg-[#15214c] opacity-50">
      <div
        className="absolute h-full bg-[#005bab] opacity-50"
        style={{ width: `${percent}%` }}
      />
      <div className="absolute py-[10px] px-0 w-full h-full">
        {percent.toFixed(0)}%
      </div>
      {percent === 100 && (
        <div className="absolute left-0 py-[10px] px-0 w-full h-full bg-[#008bd5]">
          {/** チェックマーク */}
          <span className="inline-block mr-[5px] w-3 h-[6px] align-middle border-b-2 border-l-2 border-[#fff] border-solid transform rotate-[-45deg]" />
          読了
        </div>
      )}
    </div>
  )
}
